import { defineComponent } from 'vue';
import PaymentMethodItem from './payment-method-item/payment-method-item.vue';
import { useGeoMultiMethodsStore } from '@/store/ps-management/geo-multi-methods.store';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'PaymentMethodsSettings',
  components: {
    PaymentMethodItem,
  },
  props: {
    multiMethodId: {
      type: String,
      required: true,
    },
  },
  setup() {
    const geoMultiMethodsStore = useGeoMultiMethodsStore();
    const {
      associatedPaymentMethodList,
      isAssociatedPaymentMethodListLoading,
    } = storeToRefs(geoMultiMethodsStore);

    const deleteAssociatedPaymentMethod = (methodIndex: number) => {
      associatedPaymentMethodList.value.splice(methodIndex, 1);
    };

    return {
      associatedPaymentMethodList,
      deleteAssociatedPaymentMethod,
      isAssociatedPaymentMethodListLoading,
    };
  },
});
